"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Context = /** @class */ (function () {
    function Context(_a) {
        var config = _a.config;
        this.runtime = 'browser';
        this.application = config.getStrict('projectName');
        this.version = config.getStrict('version');
    }
    return Context;
}());
exports.Context = Context;
//# sourceMappingURL=context.js.map